import { mdiArrowLeft, mdiChartBar } from '@mdi/js';
import { boundMethod } from 'autobind-decorator';
import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { t } from 'ttag';

import * as exploreActionCreators from 'uf/explore/actions/analysis';
import { getActiveAnalysisModuleKey } from 'uf/explore/selectors/analysis';
import { UFState } from 'uf/state';
import rootStyles from 'uf/styles/root.module.css';
import AnalysisModuleDetails from 'uf/ui/analysis/AnalysisModuleDetails/AnalysisModuleDetails';
import AnalysisModules from 'uf/ui/analysis/AnalysisModules/AnalysisModules';
import ErrorBoundary from 'uf/ui/base/ErrorBoundary/ErrorBoundary';
import Pane from 'uf/ui/base/Pane/Pane';
import PaneHeader from 'uf/ui/base/Pane/PaneHeader';
import tw from 'uf/tailwindcss-classnames';
import styles from './AnalysisPane.module.css';

interface StateProps {
  moduleKey: string;
  showDetails: boolean;
}

interface DispatchProps {
  setActiveAnalysisModuleKey: typeof exploreActionCreators.setActiveAnalysisModuleKey;
}

interface OwnProps {
  width?: number;
}

type AnalysisPaneProps = StateProps & DispatchProps & OwnProps;

const paneClassName = classNames(
  rootStyles.scrollY,
  styles.analysisPane,
  'AnalysisPane',
);
export class AnalysisPane extends Component<AnalysisPaneProps> {
  static defaultProps = {
    width: 0,
  };

  @boundMethod
  onCloseAnalysisDetails() {
    const { setActiveAnalysisModuleKey } = this.props;
    setActiveAnalysisModuleKey(null);
  }

  @boundMethod
  onSetActiveModule(moduleKey: string) {
    const { setActiveAnalysisModuleKey } = this.props;
    setActiveAnalysisModuleKey(moduleKey, {
      activateLayers: true,
    });
  }

  render() {
    const { moduleKey, showDetails, width } = this.props;

    let headerTitle = t`Analysis Modules`;
    let headerIconPath = mdiChartBar;
    let headerIconOnClick = null;

    if (showDetails) {
      headerTitle = t`Back to all modules`;
      headerIconPath = mdiArrowLeft;
      headerIconOnClick = this.onCloseAnalysisDetails;
    }

    return (
      <Pane column height="100%" style={{ width }} className={paneClassName}>
        <ErrorBoundary
          title={t`Error loading analysis pane`}
          componentName="AnalysisPane">
          <PaneHeader
            sticky
            className={classNames('h4', 'AnalysisPane-header', tw('tw-z-10'))}
            iconPath={headerIconPath}
            title={headerTitle}
            onClick={headerIconOnClick}
          />
          {!showDetails && (
            <AnalysisModules
              disableActiveStyling
              activeModuleKey={moduleKey}
              onSetActiveModule={this.onSetActiveModule}
            />
          )}
          {showDetails && <AnalysisModuleDetails moduleKey={moduleKey} />}
        </ErrorBoundary>
      </Pane>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps, UFState>(
  (state): StateProps => {
    const moduleKey = getActiveAnalysisModuleKey(state);
    const showDetails = !!moduleKey;
    return {
      moduleKey,
      showDetails,
    };
  },
  (dispatch: Dispatch): DispatchProps => ({
    setActiveAnalysisModuleKey: bindActionCreators(
      exploreActionCreators.setActiveAnalysisModuleKey,
      dispatch,
    ),
  }),
)(AnalysisPane);
